/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  CloudWasteSettingParameterInt,
  CloudWasteSettingParameter,
  CloudWasteSettingStatus,
  CloudWasteCategoryKey,
} from "~/generated/graphql";

export function getOpposingStatus(status: CloudWasteSettingStatus) {
  return status === CloudWasteSettingStatus.Enabled
    ? CloudWasteSettingStatus.Disabled
    : CloudWasteSettingStatus.Enabled;
}

export function isIntParameter<
  T extends {
    __typename?: CloudWasteSettingParameter["__typename"];
  }
>(
  parameter: T
): parameter is T & {
  __typename: CloudWasteSettingParameterInt["__typename"];
} {
  return parameter.__typename === "CloudWasteSettingParameterInt";
}

export const CategoryLabels = {
  [CloudWasteCategoryKey.Idle]: "Idle Resources",
  [CloudWasteCategoryKey.Orphaned]: "Orphan Resources",
  [CloudWasteCategoryKey.OverProvisioned]: "Overprovisioned Resources",
  [CloudWasteCategoryKey.Turbonomic]: "Turbonomic Actions",
} as const;
